import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElementComponent } from './simple-icons-element.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElementComponent ],
    exports:      [ SimpleIconsElementComponent ],
    bootstrap:    []
})
export class SimpleIconsElementModule {}
